import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ChatMessage, DefineDefinition } from './define.models';

export const DefineActions = createActionGroup({
  source: 'Define',
  events: {
    Load: emptyProps(),
    'Save Definition': props<{ definition: DefineDefinition }>(),
    'Set Chat Messages': props<{ messages: ChatMessage[] }>(),
  },
});
